L.Control.MapLegend = L.Control.extend({
  onAdd: function (map) {
    let img = L.DomUtil.create('img');
    // TODO: change legend URL
    img.src = 'http://2016africalandcover20m.esrin.esa.int:8080/geoserver/wms?REQUEST=GetLegendGraphic&FORMAT=image/jpeg&WIDTH=35&HEIGHT=15&LAYER=ESACCI-LC_S2:esa_cci_lc_prototype_2016_20m&LEGEND_OPTIONS=dx:10;layout:vertical;';
    img.style.width = '200px';

    let btn = L.DomUtil.create('button', 'mb-2 fp-btn-toggle-legend');
    let text = document.createTextNode('Toggle legend');
    btn.appendChild(text);
    btn.type = 'button';
    btn.setAttribute('data-toggle', 'collapse');
    btn.setAttribute('data-target', '#collapseMapLegend');

    let legendCollapsable = L.DomUtil.create('div', 'collapse');
    legendCollapsable.id = 'collapseMapLegend';
    legendCollapsable.appendChild(img);

    let wrapper = L.DomUtil.create('div', 'fp-map-legend');
    wrapper.appendChild(btn);
    wrapper.appendChild(legendCollapsable);

    return wrapper;
  },

  onRemove: function (map) {
    // Nothing to do here
  }
});

L.control.mapLegend = function (opts) {
  return new L.Control.MapLegend(opts);
}
